import { render, staticRenderFns } from "./SysAccNew.vue?vue&type=template&id=0ef9cf22&scoped=true"
import script from "./SysAccNew.vue?vue&type=script&lang=js"
export * from "./SysAccNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef9cf22",
  null
  
)

export default component.exports